import * as types from './mutation-types'

export default {
    [types.UPDATE_APP_LOADING_STATUS]: (state, data) => {
        state.isAppLoaded = data
    },

    [types.CALL_TABLES]: (state, data) => {
        state.callTables = data
    },
}
